import React, { Component } from "react";
import { Accessor, ColorX, LocaleX, NavX, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { observer } from "mobx-react";
import { HStack, Spacer, VStack, XButton, XImage, XText } from "IZOX/_X";
import _ from "lodash";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class MainSlide extends Component {

  static propTypes = {
    info: PropsType.object
  }

  static defaultProps = {
    info: {}
  }

  constructor(){
    super();
    this.state = {
      index: 0
    };
  }

  componentDidMount(){
    this._setAllStates();
    this.interval = setInterval(() => {
      this.shiftIndex();
    }, 10000);
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(MainSlide.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _toUrl = (url) => {
    NavX.NewWindow(LocaleX.Parse(url));
  }

  shiftIndex = () => {
    let {info} = this.props;
    if(!info) return;
    let length = info?.homeSlide?.length ?? 0;
    let {index} = this.state;
    let newIndex = (index + 1) % length;
    this.setState({
      index: newIndex
    });
  }

  renderContent(){
    let {info} = this.props;
    let {index} = this.state;
    let {title, content, btnCaption, btnUrl} = info?.homeSlide?.[index ?? 0] ?? {};
    return (
      <HStack pV={24}>
        <VStack width={632}>
          <XText fullWidth fontSize={32} bold color={ColorX.CSS("Grass")}>
            {LocaleX.Parse(title)}
          </XText>
          <XText fullWidth fontSize={16} bold style={{minHeight: 48, maxHeight: 48}}>
            {LocaleX.Parse(content)}
          </XText>
        </VStack>
        <Spacer/>
        <XButton width={228} onPress={() => this._toUrl(btnUrl)} round={30}
          pV={8} pH={24}
          bgColor={ColorX.CSS("Axit")} color={ColorX.CSS("pureWhite")}>
          <HStack>
            <XText bold fontSize={16}>
              {LocaleX.Parse(btnCaption)}
            </XText>
          </HStack>
        </XButton>
      </HStack>
    );
  }

  renderIndex(){
    let {index} = this.state;
    let {info} = this.props;
    let length = info?.homeSlide?.length ?? 0;
    return (
      <HStack spacing={10}>
        {_.map(_.range(0, length), (o, i) => {
          let isSelected = i === index;
          return (
            <HStack key={i} width={isSelected ? 100 : 10} height={10} round={10}
              bgColor={ColorX.CSS(isSelected ? "Grass" : "NotQuiteWhite")}/>
          );
        })}
      </HStack>
    );
  }

  renderSlide(){
    return (
      <VStack width={1064} height={260} spacing={24}
        bgColor={ColorX.CSS("pureWhite")}
        style={{ 
          position: "relative", 
          bottom: 200, 
          minHeight: 260, 
          maxHeight: 260,
          boxShadow: `1px 1px 4px 4px ${ColorX.CSS("greyOut", 0.2)}`
        }}
        pV={40} pH={80} round={15}>
        {this.renderContent()}
        {this.renderIndex()}
      </VStack>
    );
  }

  renderNormal(){
    return (
      <VStack height={850} fullWidth bgColor={ColorX.CSS("pureWhite")} pH={80}>
        <XImage source="/Images/static/housewife2.png" 
        width={SysConfig.ContentWidth}/>
        <Spacer/>
        {this.renderSlide()}
      </VStack>
    );
  }

  renderContentM(){
    let {info} = this.props;
    let {index} = this.state;
    let {title, content, btnCaption, btnUrl} = info?.homeSlide?.[index ?? 0] ?? {};
    return (
      <VStack fullWidth pT={24} spacing={30} pH={"1.2em"} >
        <HStack>
          <XText fullWidth fontSize={"1.5em"} textAlign="|"
            bold color={ColorX.CSS("Grass")}>
            {LocaleX.Parse(title)}
          </XText>
        </HStack>
        <HStack>
          <XText fullWidth fontSize={16} textAlign="|" bold>
            {LocaleX.Parse(content)}
          </XText>
        </HStack>
        <XButton width={228} onPress={() => this._toUrl(btnUrl)} round={30}
          pV={8} pH={24}
          bgColor={ColorX.CSS("Axit")} color={ColorX.CSS("pureWhite")}>
          <HStack>
            <XText bold fontSize={16}>
              {LocaleX.Parse(btnCaption)}
            </XText>
          </HStack>
        </XButton>
      </VStack>
    );
  }

  renderIndexM(){
    let {index} = this.state;
    let {info} = this.props;
    let length = info?.homeSlide?.length ?? 0;
    return (
      <HStack spacing={10}>
        {_.map(_.range(0, length), (o, i) => {
          let isSelected = i === index;
          return (
            <HStack key={i} width={isSelected ? 100 : 10} height={10} round={10}
              bgColor={ColorX.CSS(isSelected ? "Grass" : "NotQuiteWhite")}/>
          );
        })}
      </HStack>
    );
  }

  renderSlideM(){
    return (
      <VStack width={"80%"} spacing={24} mT={100}
        bgColor={ColorX.CSS("pureWhite")}
        position="relative" bottom={200} pB={20}
        style={{ 
          boxShadow: `1px 1px 4px 4px ${ColorX.CSS("greyOut", 0.2)}`
        }}
        round={15}>
        {this.renderContentM()}
        {this.renderIndexM()}
      </VStack>
    );
  }

  renderMobile(){
    return (
      <VStack fullWidth bgColor={ColorX.CSS("pureWhite")} VAlign="^">
        <XImage source="/Images/static/housewife2.png"
          width={"100%"}
          objectFit="cover"
          imgStyle={{
            width: "300%",
            maxWidth: "none",
            height: "auto",
            maxHeight: "none",
            marginLeft: "-100%"
          }}/>
        <Spacer/>
        {this.renderSlideM()}
      </VStack>
    );
  }

  render(){
    return ResponsiveX.Split({
      0: () => this.renderMobile(),
      [SysConfig.WebUIWidth]: () => this.renderNormal()
    });
  }

}

export default observer(MainSlide)  ;
